import React, { Fragment, createElement, useState } from 'react';
import { connect } from 'react-redux';
import { ComponentsManager } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import { actions, services } from '@comall-backend-builder/core';
import { message, Button } from 'antd';
const api = services.api;

const LiveBannersList: React.FC = (props: any) => {
    const { entity } = props;
    const [selectedKeys, setSelectedKeys] = useState([]);

    function onBatchHide() {
        const { entity } = props;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            const ids = selectedKeys.join(',');
            api.post({ ids, status: 'HIDE' }, { apiPath: `/live/banner/upd` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }
    function onBatchShow() {
        const { entity } = props;
        if (selectedKeys.length == 0) {
            message.warning('请至少选择一项');
        } else {
            const ids = selectedKeys.join(',');
            api.post({ ids, status: 'DISPLAY' }, { apiPath: `/live/banner/upd` })
                .then(() => {
                    // 列表数据刷新
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle);
        }
    }
    function addActionBannerBtnRender() {
        const layoutProps = {
            entity: entity,
            component: 'GridLayout',
            items: [
                {
                    component: 'LiveBannerAddPage',
                    type: 'primary',
                    span: 2,
                },
                {
                    component: 'Button',
                    text: '批量显示',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: onBatchShow,
                },
                {
                    component: 'Button',
                    text: '批量隐藏',
                    span: 3,
                    style: { marginBottom: '20px' },
                    onClick: onBatchHide,
                },
            ],
        };
        return createElement(ComponentsManager.get('GridLayout'), layoutProps);
    }

    function renderTable() {
        const { entity, componentId } = props;
        const liveRoomTable = {
            entity,
            rowKey: 'id',
            componentId: componentId + '-Table',
            loadFirstPage: true,
            rowSelection: {
                onChange: (selectedKeys: string[]) => {
                    setSelectedKeys(selectedKeys);
                },
            },
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: {
                x: true,
            },
            columns: [
                {
                    property: 'name',
                    modifiable: false,
                },
                {
                    property: 'imgUrl',
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },

                {
                    property: 'url',
                    modifiable: false,
                },
                {
                    property: 'status',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            DISPLAY: {
                                text: '是',
                            },
                            HIDE: {
                                text: '否',
                            },
                        },
                    },
                },
                {
                    property: 'sort',
                },
            ],
            actionColumn: {
                title: '操作',
                width: 160,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        text: '编辑',
                        type: 'modify',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '保存',
                        type: 'modifyConfirm',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        text: '取消',
                        type: 'modifyCancel',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        type: 'delete',
                        text: '删除',
                        config: {
                            type: 'link',
                            tooltip: null,
                            title: '确定删除当前banner吗?',
                            okText: '确定',
                            cancelText: '取消',
                        },
                    },
                ],
            },
        };
        return createElement(ComponentsManager.get('DataTable'), liveRoomTable);
    }
    return (
        <Fragment>
            {addActionBannerBtnRender()}
            {renderTable()}
        </Fragment>
    );
};

export const liveBannerList = connect()(LiveBannersList);
